<style scoped lang="stylus">
    .change-mobile {
        height: 100%
        background url(../../assets/images/login-bg.png) no-repeat
        background-size cover
    }
</style>

<template>
    <div class="change-mobile" data-flex="cross:center">
        <div class="con-box login-form">
            <van-cell-group>
                <van-field
                        v-model.trim="form.verify_num"
                        required
                        clearable
                        label="验证码"
                        placeholder="请输入验证码"
                >
                    <van-button slot="button" size="small" type="primary" :disabled="sendVerify" @click="sendVerifyCode" v-if="verifyBtTxt">{{verifyBtTxt}}</van-button>
                </van-field>
                <van-field
                        v-model.trim="form.new_mobile"
                        required
                        clearable
                        label="手机号"
                        placeholder="请输入新手机号"
                />
            </van-cell-group>
            <van-button type="primary" size="large" class="submit" :loading="loading" @click="submit">提交</van-button>
        </div>

    </div>
</template>

<script>
    import {changeMobile, sendChangeMobileSmsVerify} from "@/service/user";
    import {getVerifyTimeLeft, setSendVerifyTime, setToken} from "@/util";
    import {VERIFY_TIME, CHANGE_MOBILE_VERIFY_TIME_KEY} from "@/config";

    export default {
        props: [],
        components: {},
        data() {
            return {
                loading: false,
                form: {
                    new_mobile: '',
                    verify_num: ''
                },
                verifyBtTxtClone: '发送验证码',

                sendVerify: false, //是否已经发送验证码
                verifyBtTxt: '',
                verifyTime: '',

                timeInterval: '',
            };
        },
        created() {
            this.handleVerifyTime()
        },
        mounted() {

        },
        computed: {},
        watch: {},
        methods: {
            setVerifyTime() {
                this.intervalFac()
                this.timeInterval = setInterval(() => {
                    this.verifyTime--
                    this.intervalFac()
                }, 1000)
            },

            intervalFac() {
                if (this.verifyTime <=0) {
                    this.sendVerify = false
                    this.verifyBtTxt = this.verifyBtTxtClone
                    clearInterval(this.timeInterval)
                } else {
                    this.verifyBtTxt = `${this.verifyTime}s后重新发送`
                }
            },

            handleVerifyTime() { // 验证剩余时间
                let timeLeft = getVerifyTimeLeft(CHANGE_MOBILE_VERIFY_TIME_KEY)
                if (timeLeft) {
                    this.verifyTime = timeLeft
                    this.sendVerify = true
                    this.setVerifyTime()
                } else {
                    this.verifyBtTxt = this.verifyBtTxtClone
                }
            },
            async sendVerifyCode() {
                this.sendVerify = true //防止多次点击
                let res = await sendChangeMobileSmsVerify()
                if (res.status) {
                    this.verifyTime = VERIFY_TIME
                    this.$toast('发送成功')
                    this.setVerifyTime()
                    // 存储发送时间
                    setSendVerifyTime(CHANGE_MOBILE_VERIFY_TIME_KEY)
                } else {
                    this.$toast(res.info)
                    this.sendVerify = false
                }
            },

            async submit() {
                if (this.form.verify_num == '') {
                    this.$toast('验证码不能为空')
                    return
                }
                if (this.form.new_mobile.length != 11) {
                    this.$toast('新手机号格式不正确')
                    return
                }

                this.loading = true
                let res = await changeMobile(this.form)
                this.loading = false
                if (res.status) {
                    this.$toast('修改成功,请重新登录')
                    this.logout()
                } else {
                    this.$toast(res.info)
                }
            },
            logout() {
                setToken('')
                this.$router.replace({name: 'login'})
            },
        },
        destroyed() {
            this.timeInterval && clearInterval(this.timeInterval)
        }
    };
</script>
